import {StyleSheet} from "react-native";
import {styleVars} from "../../../app-style-vars";

export const styles = StyleSheet.create({
  searchContainer: {
    paddingVertical: styleVars.rem(.5),
    display: 'none',
  },
  searchContainerShown: {
    display: 'flex',
  },
  picker: {
    borderColor: styleVars.boschLightGray,
    borderWidth: 0,
    borderBottomWidth: 1,
    height: styleVars.rem(2.5),
    backgroundColor: '#fff',
  },
  searchInputContainer: {
    paddingVertical: styleVars.rem(.5),
  },
  searchInput: {
    height: 40,
    borderWidth: 0,
    borderBottomWidth: 1,
    borderColor: styleVars.boschLightGray,
    paddingRight: 48,
    paddingLeft: 8,
  },
  searchButton: {
    width: styleVars.rem(2.5),
    height: styleVars.rem(2.5),
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: 0,
    top: styleVars.rem(-2.5),
  },
});